export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const ARIA_LABEL_KEY = 'LinkBar_AriaLabel_SocialBarContainer';
export const ARIA_LABEL_DEFAULT = 'Social Bar';
